import { useIsAuthenticated, useMsal } from "@azure/msal-react";
import {
  getInitials,
  getTheme,
  IPersonaProps,
  Link,
  Persona,
  PersonaSize,
} from "@fluentui/react";
import {
  Menu,
  MenuItem,
  MenuList,
  MenuPopover,
  MenuTrigger,
} from "@fluentui/react-components";
import { GRAPH_PHOTO_URL } from "utils/constants";
import { useAuthImageBlob } from "utils/requests";

export const PcPersona: React.FC = () => {
  const { instance, accounts } = useMsal();
  const isAuthenticated = useIsAuthenticated();
  const { data } = useAuthImageBlob(
    !Array.isArray(accounts) ||
      !accounts[0] ||
      accounts[0].environment.includes("ppe")
      ? ""
      : GRAPH_PHOTO_URL
  );
  if (!isAuthenticated || !accounts.length) return null;

  const account = accounts[0];
  const name = account?.name;

  const persona: IPersonaProps = {
    text: name,
    imageInitials: getInitials(name, false),
    size: PersonaSize.size24,
    styles: personaStyle,
    imageUrl: data,
    secondaryText: account?.username.split("@")[1] || "",
  };

  const handleLogout = async () => {
    try {
      // Clear local session state first
      // Then do a server-side logout without redirect
      await instance.logoutRedirect({
        account: account,
        postLogoutRedirectUri: window.location.href, // Redirect back to current page
      });
    } catch (e) {
      console.error(e);
    }
  };

  return (
    <Menu positioning={{ autoSize: true }}>
      <MenuTrigger disableButtonEnhancement>
        <Link styles={linkStyle}>
          <Persona {...persona} />
        </Link>
      </MenuTrigger>
      <MenuPopover>
        <MenuList>
          <MenuItem onClick={handleLogout}>Logout</MenuItem>
        </MenuList>
      </MenuPopover>
    </Menu>
  );
};

const theme = getTheme();

const linkStyle = {
  root: {
    fontSize: 13,
    color: theme.palette.white,
    "&:hover": {
      color: theme.palette.white,
      textDecoration: "none",
    },
  },
};

const personaStyle = {
  root: {
    flexDirection: "row-reverse",
  },
  primaryText: {
    fontSize: 13,
    color: theme.palette.white,
    "&:hover": {
      color: theme.palette.white,
    },
    "&:focus": {
      color: theme.palette.white,
    },
  },
  secondaryText: {
    fontSize: 11,
    display: "block",
    color: theme.palette.white,
    "&:hover": {
      color: theme.palette.white,
    },
    "&:focus": {
      color: theme.palette.white,
    },
  },
};
